import React, { useState } from 'react';

import useUser from '@/lib/hooks/useUser';
import type { GetFeedbackData } from '@/types/database/feedback';

import CreateFeedbackModal from './components/CreateFeedbackModal';
import FeedbackList from './components/FeedbackList';
import FeedbackMessageModal from './components/FeedbackMessageModal';
import styles from './index.module.scss';

const FeedbackFrontDesk = () => {
  const [showModal, setShowModal] = useState<'create' | 'message' | null>(null);
  const [selectedFeedback, setSelectedFeedback] = useState<
    GetFeedbackData[number] | null
  >(null);

  const { user } = useUser();

  let householdNumber = '';

  if (typeof user?.householdNumbers?.[0] === 'string') {
    householdNumber = user.householdNumbers[0];
  }

  return (
    <div className={styles.mobileFeedbackPage}>
      {!showModal && (
        <FeedbackList
          householdNumber={householdNumber}
          handleCreate={() => setShowModal('create')}
          handleShowMessage={(feedback) => {
            setSelectedFeedback(feedback);
            setShowModal('message');
          }}
        />
      )}
      {showModal === 'create' && (
        <CreateFeedbackModal
          onClose={() => setShowModal(null)}
          user={{ id: user._id, name: user.name }}
          houseNumber={user.householdNumbers?.[0]}
        />
      )}
      {showModal === 'message' && selectedFeedback && (
        <FeedbackMessageModal
          feedbackId={selectedFeedback._id}
          title={selectedFeedback.title}
          user={{ id: user._id, name: user.name }}
          onClose={() => {
            setShowModal(null);
            setSelectedFeedback(null);
          }}
        />
      )}
    </div>
  );
};

export default FeedbackFrontDesk;
